import { useEffect, useState } from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import InOutReadingTable from "../standardInOut/inOutReadingTable";
import axiosWithToken from "../../utils/components/axiosTokenConfig";
import { toast } from "react-toastify";
import { BASE_URL } from "../../global";
import { Tooltip, Toolbar, Button, } from "@mui/material";
import EditWrap from "../commonComponent/editWrap";

const initialColumns = [
  {
    id: "standardReading",
    label: "STANDARD READINGS",
    accessor: "standardReading",
    dataType: "text",
  },
  {
    id: "actualMeasuredReading",
    label: "ACTUAL MEASURED READINGS",
    accessor: "actualMeasuredReading",
    dataType: "text",
  },
  { id: "error", label: "ERROR", accessor: "error", dataType: "text" },
  {
    id: "acceptanceCriteria",
    label: "ACCEPTANCE CRITERIA",
    accessor: "acceptanceCriteria",
    dataType: "text",
  },
];

const initialData = [
  {
    standardReading: "",
    actualMeasuredReading: "",
    error: "",
    acceptanceCriteria: "",
  },
  {
    standardReading: "",
    actualMeasuredReading: "",
    error: "",
    acceptanceCriteria: "",
  },
];

const ChallanCalibration = () => {
  const params = useParams();
  const [editAccess, setEditAccess] = useState(
    localStorage.getItem("editAccess")?.split(",").map(Number)
  );
  const [beforeCalibrationData, setBeforeCalibrationData] = useState(
    JSON.parse(JSON.stringify(initialData))
  );
  const [afterCalibrationData, setAfterCalibrationData] = useState(
    JSON.parse(JSON.stringify(initialData))
  );
  const [deletedRowIds, setDeletedRowIds] = useState([]);
  const [challanDetails, setChallanDetails] = useState({});

  const [letterHead, setLetterHead] = useState(true);

  var refresh = () => {
    window.location.reload(false);
  };

  const getStdInOutReadings = (challanInOutId) => {
    let url = BASE_URL;

    let payload = {
      query: `SELECT * FROM stdInOutReadings WHERE challanInOutId = ${challanInOutId}`,
    };

    axiosWithToken
      .post(`${url}dynamic`, payload)
      .then((res) => {
        const beforeCalibrationData = res.data
          .filter((item) => item.type === 1)
          .map(({ type, ...rest }) => rest);

        const afterCalibrationData = res.data
          .filter((item) => item.type === 2)
          .map(({ type, ...rest }) => rest);

        setBeforeCalibrationData(beforeCalibrationData);
        setAfterCalibrationData(afterCalibrationData);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something went wrong!");
        }
      });
  };
  const deleteReadings = () => {
    let url = BASE_URL;
    let query = {
      query: `DELETE FROM stdInOutReadings WHERE id IN (${deletedRowIds.join(
        ","
      )})`,
    };

    axiosWithToken
      .post(url + `dynamic`, query)
      .then((res) => {})
      .catch((error) =>console.log(error));
  };

  const submitStdInOutReadings = (challanInOutId) => {
    const url = BASE_URL;

    const payload = [
      ...beforeCalibrationData.map((data) => ({
        ...data,
        challanInOutId,
        stdInOutId: 0,
        type: 1,
      })),
      ...afterCalibrationData.map((data) => ({
        ...data,
        challanInOutId,
        stdInOutId: 0,
        type: 2,
      })),
    ];

    const updatePayload = payload.filter((data) => data.id);
    const submitPayload = payload.filter((data) => !data.id);

    const requests = [
      submitPayload.length &&
        axiosWithToken.post(`${url}stdInOutReadings/bulk`, submitPayload),
      updatePayload.length &&
        axiosWithToken.patch(`${url}bulk/stdInOutReadings`, updatePayload),
    ].filter(Boolean);

    if (requests.length) {
      Promise.all(requests)
        .then(async(res) => {
        deletedRowIds?.length > 0 &&  await deleteReadings();         
          toast.success(
            `standards In/Out ${
              params.id ? "updated" : "created"
            } successfully!`
          );
          setTimeout(refresh, 500);
        })
        .catch((error) => console.log(error));
    }
  };

  const getChallanData = (id) => {
    let url = BASE_URL;

  let payload = { query: `SELECT sIOC.*, s.stId, s.standardName FROM standardInOutChallan sIOC LEFT JOIN standards s ON sIOC.standardtIds = s.id WHERE sIOC.id = ${id}` };


    axiosWithToken
      .post(`${url}dynamic`, payload)
      .then((res) => {
        setChallanDetails(res.data?.[0]);
      })
      .catch((error) => {
        if (error.message !== "request_aborted") {
          toast.error("Something went wrong!");
        }
      });
  };

  useEffect(() => {
    if (params.id != 0) {
      getStdInOutReadings(params.id);
      getChallanData(params.id);
    }
  }, [params.id != 0]);

  return (
    <EditWrap>     

      <br />
      <h6
        style={{
          fontSize: "20px",
          textAlign: "center",
          fontWeight: "bold",
          marginTop: "10px",
        }}
      >
        {`Before Calibration for (${challanDetails?.stId || ""} : ${challanDetails?.standardName || ""})`}
      </h6>
      <InOutReadingTable
        initialColumns={initialColumns}
        data={beforeCalibrationData}
        setData={setBeforeCalibrationData}
        srNo={true}
        deletedRowIds={deletedRowIds}
        setDeletedRowIds={setDeletedRowIds}
      />

      {params.id != 0 && (
        <>
          <hr />
          <br />
          <h6
            style={{
              fontSize: "20px",
              textAlign: "center",
              fontWeight: "bold",
              marginTop: "10px",
            }}
          >
            {`After Calibration for (${challanDetails?.stId || ""} : ${challanDetails?.standardName || ""})`}
          </h6>
          <InOutReadingTable
            initialColumns={initialColumns}
            data={afterCalibrationData}
            setData={setAfterCalibrationData}
            srNo={true}
            deletedRowIds={deletedRowIds}
            setDeletedRowIds={setDeletedRowIds}
          />
        </>
      )}

      <hr />
      <br />

      <Toolbar
        style={{
          padding: "0px",
          overflow: "auto",
          display: "flex",
          justifyContent: "flex-end",
          gap: "20px",
          marginTop: "3rem",
        }}
      >
        {/* { params.id != 0  && (
             <>
             <Autocomplete
                size="small"
                sx={{minWidth:"200px"}}
                options={[
                  { id: 1, label: "With Letter Head" },
                  { id: 2, label: "Without Letter Head" },
                ]}
                renderInput={(params) => <TextField {...params} label="letterHead" />}
                onInputChange={(event, newInputValue) => {
                  if (newInputValue === "With Letter Head" || newInputValue === "") {
                    setLetterHead(true);
                  } else if (newInputValue === "Without Letter Head") {
                    setLetterHead(false);
                  }
                }}
              />
      
             <Button
                variant="contained"
                size="small"
                onClick={() => {
                  const client = clientsOption?.find(ele => ele.id == companyName);
                  const addressData = allAddress?.find(ele => ele.id == address);
                  const instrumentData = standardArr?.find(ele => ele.id == standardDetails?.standardId);
                  generatePDF1(checkPointData, standardDetails, client, addressData,beforeCalibrationData,afterCalibrationData,instrumentData,letterHead);
                }}
                
              >
                print
              </Button>
            </>
           )} */}
        <Button
          variant="contained"
          style={{ backgroundColor: "grey" }}
          size="small"
          onClick={() => {
            if (window.confirm("Are you sure you want to cancel?")) {
              window.history.back();
            }
          }}
        >
          Cancel
        </Button>

        <Tooltip
          title={
            !(editAccess?.includes(1) || editAccess?.includes(0))
              ? "You don't have access"
              : ""
          }
        >
          <Button
            variant="contained"
            size="small"
            sx={{ m: 0 }}
            disabled={!(editAccess?.includes(1) || editAccess?.includes(0))}
            onClick={() => {
              submitStdInOutReadings(params.id);
            }}
          >
            {params.id == 0 ? "Save" : "Update"}
          </Button>
        </Tooltip>
      </Toolbar>
    </EditWrap>
  );
};

export default ChallanCalibration;
